import { useEffect } from 'react';
import { useNavigate, createFileRoute } from '@tanstack/react-router';
import {
  useKlaviyoBrands,
  KlaviyoEntryShell,
  KlaviyoBrandPicker,
  brandKlaviyoSettingsPath,
} from '@/components/settings/KlaviyoBrandPicker';

import { Box, CircularProgress } from '@mui/material';

import { STORAGE_KEY_ACTIVE_CLIENT } from 'src/lib/active-tenant';

// Klaviyo's app listing links here as the settings URL. Brand-agnostic: go to
// the last-used brand's Klaviyo page when there is one (or only one brand),
// else let the user pick.
export const Route = createFileRoute('/_authed/integrations/klaviyo/')({
  component: KlaviyoSettingsEntryPage,
});

function lastUsedClientId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY_ACTIVE_CLIENT);
  } catch {
    return null;
  }
}

function KlaviyoSettingsEntryPage() {
  const navigate = useNavigate();
  const { brands, isLoading } = useKlaviyoBrands();

  const lastUsedId = lastUsedClientId();
  const target =
    brands.find((b) => b.id === lastUsedId) ?? (brands.length === 1 ? brands[0] : undefined);

  const targetPath = target ? brandKlaviyoSettingsPath(target) : null;

  useEffect(() => {
    if (!isLoading && targetPath) {
      navigate({ to: targetPath, replace: true });
    }
  }, [isLoading, targetPath, navigate]);

  return (
    <KlaviyoEntryShell>
      {isLoading || targetPath ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <KlaviyoBrandPicker mode="settings" />
      )}
    </KlaviyoEntryShell>
  );
}
